// @ts-nocheck
import PropTypes from "prop-types";
import {ErrorBoundary, useErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {BaseButton} from "@/components";
import {useLogo} from "../../../util/logoUtils";

const containerCls = "flex m-4 flex-col justify-center items-center h-[50vh] text-[var(--color-warning)]";
const logoCls = "w-[var(--size-50)] mb-4 max-md:w-[150px]";
const titleCls = "text-[clamp(18px,2vw,25px)] font-normal mb-4 text-center";
const actionCls = "text-base mb-4 text-center";

const FallbackComponent = () => {
  const {t} = useTranslation();
  const {resetBoundary} = useErrorBoundary();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    window.location.href = "/";
    resetBoundary();
  };

  return (
    <div className={containerCls}>
      <img
        src={logoImg}
        alt="Logo"
        className={logoCls}
      />
      <p className={titleCls}>{t("errorBoundaryHandler1")}</p>
      <p className={actionCls}>{t("errorBoundaryHandler2")}</p>
      <BaseButton
        variant="primary"
        onClick={handleErrorState}
      >
        {t("errorBoundaryBtnReload")}
      </BaseButton>
    </div>
  );
};

export const ErrorBoundaryHome = ({children}) => {
  return (
    <div>
      <ErrorBoundary FallbackComponent={FallbackComponent}>{children}</ErrorBoundary>
    </div>
  );
};

ErrorBoundaryHome.propTypes = {
  children: PropTypes.node,
};
